import * as React from 'react';

const Loading = ({ isLoading, children, height = null }) => {
	if (isLoading) {
		return (
			<div className="pfa-loading" style={{ height }}>
				<div className="pfa-loading__spinner" />
			</div>
		);
	}
	return <>{children}</>;
};

Loading.displayName = 'Loading';

export default Loading;
